
import React from "react";
import { HeroCTA } from "./HeroCTA";
import { AvatarStrip } from "./AvatarStrip";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

type HeroContentProps = {
  onOpenWaitlist: () => void;
};

export const HeroContent = ({ onOpenWaitlist }: HeroContentProps) => {
  return (
    <div className="flex flex-col space-y-6">
      <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-[#1211ca]/10 w-fit">
        <span className="bg-[#614AE0] text-white text-xs font-medium px-2.5 py-0.5 rounded-full">New</span>
        <span className="text-sm font-medium">Your Financial Hype Squad 💅✨</span>
      </div>
      
      <div className="mb-1">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight">
          <span className="text-gradient block">Financial Freedom</span>
          <span className="text-gradient-blue block mt-2">That Feels Like You</span>
        </h1>
      </div>
      
      <p className="text-lg md:text-xl text-gray-600 max-w-xl pr-8">
        Savyi isn't just an app—it's your financial sixth sense. We see the whole picture: bank feeds, crumpled receipts, angry creditor letters, and your midnight "I need a win" moments.
      </p>
      
      <HeroCTA onOpenWaitlist={onOpenWaitlist} />
      
      <Link 
        to="/bright-plan"
        className="group inline-flex items-center text-savyi-purple hover:text-savyi-purple/80 transition-colors mt-2 w-fit"
      >
        <span className="font-medium">View your financial journey roadmap</span>
        <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
      </Link>
      
      <AvatarStrip />
    </div>
  );
};
